var _defs, _path, _path2, _polyline, _polyline2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse, _rect, _ellipse2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMandarincollar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-63,.cls-53,.cls-52,.cls-61{fill:#fff;}.cls-54,.cls-62,.cls-60,.cls-59,.cls-58,.cls-57,.cls-56,.cls-55{fill:none;}.cls-54,.cls-62,.cls-61,.cls-60,.cls-59,.cls-58,.cls-57,.cls-56,.cls-55{stroke:#000;}.cls-54,.cls-53,.cls-52,.cls-62,.cls-61,.cls-60,.cls-59,.cls-58,.cls-57,.cls-56,.cls-55{stroke-miterlimit:10;}.cls-62,.cls-61{stroke-width:2px;}.cls-54,.cls-60,.cls-59,.cls-58,.cls-57,.cls-56,.cls-55{stroke-width:0.75px;}.cls-59{stroke-dasharray:3.04 3.04;}.cls-58{stroke-dasharray:2.98 2.98;}.cls-57{stroke-dasharray:3.04 3.04;}.cls-56{stroke-dasharray:2.98 2.98;}.cls-55{stroke-dasharray:2.99 2.99;}.cls-54{stroke-dasharray:2.97 2.97;}.cls-53,.cls-52{stroke:#010101;}.cls-53{stroke-width:2.7px;}.cls-52{stroke-dasharray:2.7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M307.9,177.47v2.24a57.84,57.84,0,0,1-6.84,11c-17,21.81-51.1,36.69-90.37,36.69h0a16.19,16.19,0,0,0-5.37.91c-37-1.29-68.74-15.79-85-36.59a57.9,57.9,0,0,1-7.09-11.55s0,0,0,0c-.24-.52-.47-1-.68-1.57v-3.06c.21.52.44,1.05.68,1.57,0,0,0,0,0,0l.19.4c13-20.7,51.6-35.72,97.27-35.72S294.89,156.82,307.9,177.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M372.56,217.22,368.9,388.11H54.23L50.66,217.75l59.19-21.41c2.23,7.19,5.42,16.32,8.77,22.07,17,29.35,54.88,37,76.63,38.93,4.88.44,8.95.59,11.79.63h.4c1,0,1.85,0,2.5,0h.38l1.1,0h.29l1.1,0h.4c2.11,0,6.29,0,11.79-.39.92-.07,1.88-.14,2.88-.24,21.74-1.93,59.64-9.58,76.63-38.93,3.45-5.94,6.92-15.95,9.21-23.37Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-62",
    points: "50.01 217.53 53.58 216.23 109.2 196.06 112.77 194.76"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-62",
    points: "371.91 217 368.25 215.62 313.07 194.82 310.89 194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M210.92,227.5h0a16.27,16.27,0,0,1,16.28,16.27v19.39h-16.3c-39.27,0-73.36-14.88-90.37-36.69C113.17,217,109,206.29,109,194.88V159.21c0,1,0,1.94.1,2.9a0,0,0,0,0,0,0,48.27,48.27,0,0,0,4.35,17.09s0,0,0,0a58.25,58.25,0,0,0,7.09,11.56C137.56,212.62,171.65,227.5,210.92,227.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M210.92,260.11c-37.17,0-70.88-13.61-88-35.51-7.24-9.26-10.9-19.26-10.9-29.72V183.31a62.05,62.05,0,0,0,6.08,9.38c18.21,23.35,53.76,37.86,92.78,37.86a13.25,13.25,0,0,1,13.25,13.22v16.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M112.06,184.81v-1.5c.23.44.47.88.71,1.32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M114.32,187.25a62.06,62.06,0,0,0,3.82,5.44c18.21,23.35,53.76,37.86,92.78,37.86a13.25,13.25,0,0,1,13.25,13.22v13.31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M224.17,258.61v1.5h-1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M219.69,260.11h-8.77c-37.17,0-70.88-13.61-88-35.51-7.24-9.26-10.9-19.26-10.9-29.72V186.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M210.92,226.48h0a16.27,16.27,0,0,0-16.28,16.27v19.39h16.31c39.27,0,73.36-14.88,90.37-36.69,7.38-9.45,11.54-20.19,11.54-31.6V158.19c0,1,0,1.94-.1,2.9a0,0,0,0,1,0,0,47.85,47.85,0,0,1-4.35,17.09s0,0,0,0a58.2,58.2,0,0,1-7.08,11.56C284.28,211.6,250.19,226.48,210.92,226.48Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M197.67,259.09V242.75a13.23,13.23,0,0,1,13.22-13.22c39,0,74.59-14.51,92.81-37.86a62.83,62.83,0,0,0,6.08-9.38v11.57c0,10.46-3.67,20.46-10.9,29.72-17.09,21.9-50.79,35.51-88,35.51Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M199.17,259.09h-1.5v-1.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M197.67,254.55v-11.8a13.23,13.23,0,0,1,13.22-13.22c39,0,74.59-14.51,92.81-37.86a65.33,65.33,0,0,0,4.61-6.74"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M309.06,183.61c.25-.44.48-.87.72-1.32v1.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M309.78,186.77v7.09c0,10.46-3.67,20.46-10.9,29.72-17.09,21.9-50.79,35.51-88,35.51H200.65"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M312.73,159.05a0,0,0,0,1,0,0,47.85,47.85,0,0,1-4.35,17.09s0,0,0,0l-.18.4c-13-20.7-51.6-35.72-97.27-35.72s-84.32,15-97.27,35.72l-.19-.4s0,0,0,0a48.27,48.27,0,0,1-4.35-17.09,0,0,0,0,1,0,0c2.31-27.12,47-48.76,101.82-48.76S310.43,131.93,312.73,159.05Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M307.41,170.33c-16.29-19.64-53.93-32.52-96.49-32.52s-80.21,12.88-96.5,32.52a44.25,44.25,0,0,1-2.25-11.23c2.37-25.25,46.58-45.75,98.75-45.75s96.37,20.5,98.75,45.75A44.27,44.27,0,0,1,307.41,170.33Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M307.87,168.9c-.14.48-.29,1-.46,1.43-.31-.38-.64-.76-1-1.14"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M304.4,167c-17.62-17.76-53.37-29.2-93.48-29.2-40.92,0-77.29,11.9-94.52,30.27"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M115.39,169.19l-1,1.14c-.16-.47-.31-1-.46-1.43"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M113.2,166a43.1,43.1,0,0,1-1-6.93c2.37-25.25,46.58-45.75,98.75-45.75s96.37,20.5,98.75,45.75a44.46,44.46,0,0,1-1.39,8.37"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M194.11,387.89l0-3,.88-119,0-2.75c6.74.6,11.89.63,14.28.6h.39l1.07,0h.29l1.07,0h.37c.63,0,1.45,0,2.43,0h.39c2.77,0,6.73-.18,11.48-.6v.23l0,3,.88,118.49,0,3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M197.13,384.89,198,266.41c4.34.3,7.86.37,10.21.37,1.33,0,2.19,0,2.5,0h.34c.36,0,1.22,0,2.55,0,2.35,0,5.87-.07,10.21-.37l.88,118.48"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.91,
    cy: 282.16,
    rx: 6.71,
    ry: 6.41
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 210.22,
    y: 273.45,
    width: 1.39,
    height: 17.84
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.92,
    cy: 366.16,
    rx: 6.71,
    ry: 6.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.22,
    y: 357.45,
    width: 1.39,
    height: 17.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandarincollar01);
export default __webpack_public_path__ + "static/media/MANDARIN COLLAR-01.478e1c1a39dd77729190e922021748ef.svg";
export { ForwardRef as ReactComponent };